<ng-container *ngIf="model">
  <div class="static-search-content">
    @if (model.invokeType === 'open-chat') {
      <assistant-icon
        [model]="model.data?.assistant"
        [spriteEmojiSize]="16"
        [iconStyles]="{ 'font-size': '16px', height: '16px', width: '16px' }"
      ></assistant-icon>
    } @else {
      <entity-icon [model]="model.icon" [size]="'16px'" [spriteEmojiSize]="16"></entity-icon>
    }
    <div class="text-container">
      <span
        >{{ model.title }}
        <span *ngIf="model.subTitle" class="sub-title"
          >“<strong>{{ model.subTitle }}</strong
          >”</span
        >
      </span>
      <span *ngIf="model.description" class="description">{{ model.description }}</span>
    </div>
  </div>
  <div class="enter-indication">
    <u-icon
      [model]="{ type: 'font', value: 'icon-key-enter' }"
      [style]="{ fontSize: '12px', color: 'var(--color-text-tertiary)' }"
    ></u-icon>
  </div>
</ng-container>
